export const FETCHING_ITEMS = 'FETCHING_ITEMS';
export const FETCHED_ITEMS = 'FETCHED_ITEMS';
export const SET_GRID_FILTER = 'SET_GRID_FILTER';
export const UNSET_GRID_FILTER = 'UNSET_GRID_FILTER';
export const SET_ITEMS_GRID_PER_PAGE_RECORDS = 'SET_ITEMS_GRID_PER_PAGE_RECORDS';
export const SET_ITEMS_GRID_CURRENT_PAGE = 'SET_ITEMS_GRID_CURRENT_PAGE';
export const SET_ITEMS_GRID_SORT_CRITERIA = 'SET_ITEMS_GRID_SORT_CRITERIA';
export const SET_ITEMS_GRID_FILTER_CRITERIA = 'SET_ITEMS_GRID_FILTER_CRITERIA';


// WEBPACK FOOTER //
// ./src/containers/grid/types.js